var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from "react";
import { InputAdornment, makeStyles } from "@material-ui/core";
import { FTLTextField } from "../FTLTextField";
import { VisibilityIcon } from "../icons";
import { FTLIconButton } from "../FTLIconButton";
export const FTLPasswordField = (_a) => {
    var { isVisible, InputProps } = _a, other = __rest(_a, ["isVisible", "InputProps"]);
    const [value, setValue] = useState(null);
    const [areVisible, setIsVisible] = useState(isVisible ? true : false);
    const handleClickShowPassword = () => setIsVisible(!areVisible);
    const classes = useStyles();
    return (React.createElement(FTLTextField, Object.assign({ type: areVisible ? "text" : "password", value: value, onChange: (e) => setValue(e.target.value), InputProps: Object.assign({ endAdornment: (React.createElement(InputAdornment, { position: "end" },
                React.createElement(FTLIconButton, { tabIndex: -1, disabled: other.disabled, className: classes.icon, onClick: handleClickShowPassword },
                    React.createElement(VisibilityIcon, { open: areVisible })))) }, InputProps) }, other)));
};
const useStyles = makeStyles({
    icon: {
        zIndex: 1,
        "&:hover": {
            backgroundColor: "initial",
        },
    },
});
//# sourceMappingURL=index.js.map